import React, { useEffect, useState } from "react";
import styles from './feedbackform.module.scss'
import { FaXmark } from "react-icons/fa6";
import { closeFeedback } from "../../store/Partner/modalSlice";
import { useDispatch } from "react-redux";

// import sendTelegramMessage from '../../services/Telegram/TelegramService'
import Button from "../Button/Button";

const ratingsData = [
  { rating: 1, description: "Very Dissatisfied" },
  { rating: 2, description: "Dissatisfied" },
  { rating: 3, description: "Slightly Dissatisfied" },
  // { rating: 3, description: "Neutral" },
  { rating: 4, description: "Satisfied" },
  { rating: 5, description: "Very Satisfied" },
];

export default function FeedbackForm() {
  // const userState = useSelector((state) => state.partner);
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);
  const dispatch=useDispatch();
  const handleClose=()=>{
    dispatch(closeFeedback());
  }

  const [formData, setFormData] = useState({
    // partnerName: userState.user && userState.user.username,
    // userEmail: userState.user && userState.user.email,
    // contact_number: userState.user && userState.user.contact_number,
    // rating: null,
    // feedback: "",
  });

  const handleSubmit = async () => {
    // Remove newline characters from feedback
    const cleanFeedback = formData.feedback.replace(/\n/g, " ");
    if (formData.rating === null || formData.rating < 0 || formData.rating > 5) {
      // toast.error("Please select a rating from 0 to 5!");
      return;
    }
    const message = `
    🌟🌟🌟🌟🌟 *User Feedback* 🌟🌟🌟🌟🌟\n
    Username: ${formData.partnerName}
    Email: ${formData.userEmail}
    Phone Number: ${formData.contact_number}
    Rating: ${formData.rating} out of 5 (${ratingsData[formData.rating].description
      })
    Feedback: ${cleanFeedback}
    `;

    // setLoading(true);
    try {
      const token = process.env.REACT_APP_TELEGRAM_TOKEN;
      const chat_id = process.env.REACT_APP_TELEGRAM_FEEDBACK_CHATID;
      // await sendTelegramMessage(token, chat_id, message);
      //setOpenFeedBackForm(false);
      handleClose();
      // toast.success("Thank you for your feedback!");
    } catch (error) {
      // toast.error("Failed to submit feedback! Please try again after some time!");
      // setError(error);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <div className= 'container-background content-center'>
      <div className={styles.feedbackForm}>
        <FaXmark
          className={styles.closeFeedbackForm}
          onClick={handleClose}
        />
        <div className={styles.ratingContainer}>
          <h2>
            How likely are you to recommend our company to a friend or
            colleague?
          </h2>

          <div className={styles.ratingBox}>
            <ul className={styles.ratings}>
              {ratingsData.map((rating) => (
                <li
                  title={rating.description}
                  key={rating.rating}
                  style={{
                    backgroundColor: `rgba(${255 - rating.rating * 50}, ${100 + rating.rating * 30
                      }, 0, 1)`,
                  }}
                  className={`${formData.rating === rating.rating ? styles.activeRating : ""
                    }`}
                  onClick={() => {
                    setFormData({
                      ...formData,
                      rating: rating.rating,
                    });
                  }}
                >
                  {rating.rating}
                </li>
              ))}
            </ul>
            <p className={styles.ratingNote}>
              <span> <span>1</span>: Very Dissatisfied 😠</span>
              <span> <span>5</span>: Very Satisfied 😊</span>
            </p>

            <div className={styles.feedbackText}>
              <textarea
                name=""
                placeholder="Enter feedback or suggestions you have..."
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    feedback: e.target.value,
                  });
                }}
                value={formData.feedback}
              ></textarea>
            </div>

            <div className={styles.feedbackBtn}>
              <Button
                handleClick={handleSubmit}
                // label={loading ? "Submitting...!" : "Submit"}
                label={'Submit Feedback'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
